import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=2ddffc6f&"
var script = {}
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/opt/build/repo/storefront/components/atoms/Button/BaseButton.vue').default})
